export enum SearchMode {
  ROUND_TRIP = 'RT',
  ONE_WAY = 'OW',
  MULTI_TRIP = 'MT',
}
